import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseControl,
  Textbox,
  Custom,
  Dropdown,
  Container,
  ValoresOperacionesControl,
  TipoControl
} from '@app/shared';


@Injectable()
export class CreationValueOperactionFormsService {
  constructor() { }

  /**
   * Genera el formulario para agregar un valor
   *
   * @param {*} template
   * @param {*} options
   * @param {TipoControl} typeControl Se utilizara en un futuro para generar los formularios personalizados por tipo
   * @param {ValoresOperacionesControl} [value]
   * @returns {BaseControl<any>[]}
   * @memberof CreationValueOperactionFormsService
   */
  getOperaction(
    template: any,
    options: any,
    typeControl: TipoControl,
    value?: ValoresOperacionesControl,
  ): BaseControl<any>[] {

    let control: BaseControl<any> = new Textbox({
      key: 'txtReferencia',
      label: 'Referencia dentro de la operacion',
      placeholder: 'Ingrese la referencia dentro de la operacion',
      value: value ? value.referencia : null,
      size: 'col-12',
      validations: {
        // tslint:disable-next-line:quotemark
        validators: [
          Validators.required,
          // Se comenta esta validacion ya que no se encontro una expresion regular que cumpa con
          // Las condiciones necesarias, pero es necesario darle una a este campo
          // Validators.pattern("([A-Za-z])\w*")
        ]
      }
    });
    if (
      typeControl.nombre === 'ngSelect' ||
      typeControl.nombre === 'email' ||
      typeControl.nombre === 'checkbox'
    ) {
      control = new Textbox({
        key: 'txtReferencia',
        label: 'Referencia dentro de la operacion',
        placeholder: 'Ingrese la referencia dentro de la operacion',
        value: value ? value.referencia ? value.referencia : 'valor' : 'valor',
        size: 'col-12',
        disabled: true,
        validations: {
          validators: [
            Validators.required,
          ]
        }
      });
    }

    const controls: BaseControl<any>[] = [
      new Container({
        class: 'form-row form-check form-check-inline col-12',
        order: 1,
        controls: [
          new Dropdown({
            key: 'cboAplicaForma',
            label: 'Tipo de valor',
            options: [
              { key: 'Formulario', value: 'Formulario' },
              { key: 'Valor especifico', value: 'Valor específico' },
              { key: 'Resultado condicion', value: 'Resultado condicion' },
            ],
            value: value ?
                    value.forma ?
                      'Formulario'
                    : value.valor === null ?
                      'Resultado condicion'
                    : value['tipoValor'] ?
                      value['tipoValor']
                    : 'Valor especifico'
                   : 'Formulario',
            size: 'col-12',
            validations: {
              validators: [Validators.required]
            }
          }),
        ]
      }),
      new Container({
        class: 'form-row form-check form-check-inline col-12',
        order: 2,
        condictions: [
          {
            campoDepende: 'cboAplicaForma',
            siEs: 'Igual',
            valor: 'Formulario',
            accion: 'Mostrar'
          }
        ],
        controls: [
          new Custom({
            key: 'cboForm',
            label: 'Forma:',
            value: value ? value.forma : null,
            template: template,
            options: options['forms'] ? options['forms'] : [],
            size: 'col-md-4',
            placeholder: 'Seleccionar la forma donde se encuentra el campo',
            validations: {
              validators: [Validators.required]
            },
            condictions: [
              {
                campoDepende: 'cboAplicaForma',
                siEs: 'Igual',
                valor: 'Formulario',
                accion: 'Mostrar'
              }
            ]
          }),
          new Custom({
            key: 'cboFormulario',
            label: 'Formulario:',
            value: value ? value.formulario : null,
            template: template,
            options: options['formularios'] ? options['formularios'] : [],
            size: 'col-md-4',
            placeholder: 'Seleccionar el formulario donde se encuentra el campo',
            validations: {
              validators: [Validators.required]
            },
            condictions: [
              {
                campoDepende: 'cboAplicaForma',
                siEs: 'Igual',
                valor: 'Formulario',
                accion: 'Mostrar'
              }
            ]
          }),
          new Custom({
            key: 'cboField',
            label: 'Campo:',
            value: value ? value.campo : null,
            template: template,
            options: options['field'] ? options['field'] : [],
            size: 'col-md-4',
            placeholder: 'Seleccionar el campo que contiene el valor',
            validations: {
              validators: [Validators.required]
            },
            condictions: [
              {
                campoDepende: 'cboAplicaForma',
                siEs: 'Igual',
                valor: 'Formulario',
                accion: 'Mostrar'
              }
            ]
          }),
          new Textbox({
            key: 'txtValor',
            label: 'Valor',
            placeholder: 'Ingrese el valor',
            value: value ? value.valor  : null,
            size: 'col-12',
            validations: {
              validators: [Validators.required]
            },
            condictions: [
              {
                campoDepende: 'cboAplicaForma',
                siEs: 'Igual',
                valor: 'Valor especifico',
                accion: 'Mostrar'
              }
            ]
          }),
        ]
      }),
      new Container({
        class: 'form-row form-check form-check-inline col-12',
        order: 3,
        controls: [
          control,
        ]
      }),
    ];

    return controls;
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/conditions/operations-condition-form/creation-operation-condition/creation-operation-condition-value/shared/creation-operation-value.forms.service.ts